const vendors = [
  'BrightBlu',
  'Mass-Tech',
  'Sichuan Weiyu Electric Co. Ltd',
  'Shenzhen BDcharge IOT Technologies Co. Ltd',
  'Joulepoint Simulator',
];

export default vendors;
